import React from 'react';

const missing = 'No informado en la captura';
const labels = {
  sourceServerID: 'ID del servidor protegido', arn: 'ARN', agentVersion: 'Versión del agente',
  recoveryInstanceId: 'Instancia de recuperación', lastLaunchResult: 'Resultado del último lanzamiento',
  isArchived: 'Archivado', replicationDirection: 'Dirección de replicación',
  identificationHints: 'Identificación', hostname: 'Nombre del servidor', fqdn: 'Nombre de dominio completo',
  awsInstanceID: 'ID de instancia AWS del origen', vmWareUuid: 'UUID de VMware',
  os: 'Sistema operativo', fullString: 'Descripción',
  cpus: 'Procesadores', cores: 'Núcleos', modelName: 'Modelo',
  ramBytes: 'Memoria RAM (GiB)', disks: 'Discos del origen', deviceName: 'Dispositivo',
  bytes: 'Capacidad (GiB)', networkInterfaces: 'Interfaces de red', ips: 'Direcciones IP',
  isPrimary: 'Interfaz principal', macAddress: 'Dirección MAC',
  recommendedInstanceType: 'Tipo de instancia recomendado', supportsNitroInstances: 'Admite instancias Nitro',
  lastUpdatedDateTime: 'Última actualización',
  dataReplicationState: 'Estado de replicación', lagDuration: 'Retraso de replicación',
  etaDateTime: 'Finalización estimada', stagingAvailabilityZone: 'Zona de disponibilidad de staging',
  stagingOutpostArn: 'ARN de Outpost de staging', dataReplicationError: 'Error de replicación',
  error: 'Código de error', rawError: 'Detalle del error',
  dataReplicationInitiation: 'Inicio de replicación', startDateTime: 'Inicio',
  nextAttemptDateTime: 'Próximo intento', steps: 'Pasos de inicio de replicación',
  name: 'Paso', status: 'Estado', replicatedDisks: 'Discos replicados',
  backloggedStorageBytes: 'Datos pendientes (GiB)', replicatedStorageBytes: 'Datos replicados (GiB)',
  rescannedStorageBytes: 'Datos reexaminados (GiB)', totalStorageBytes: 'Datos totales (GiB)',
  volumeStatus: 'Estado del volumen', addedToServiceDateTime: 'Alta en el servicio',
  elapsedReplicationDuration: 'Tiempo de replicación transcurrido',
  firstByteDateTime: 'Primer dato replicado', lastSeenByServiceDateTime: 'Último contacto con el servicio',
  lastLaunch: 'Último lanzamiento', initiated: 'Solicitud', apiCallDateTime: 'Fecha de solicitud',
  jobID: 'ID del trabajo', type: 'Tipo', state: 'Estado',
  lastTest: 'Última prueba', lastRecovery: 'Última recuperación',
  stagingAccountID: 'Cuenta de staging', stagingSourceServerArn: 'ARN del servidor de staging',
  errorMessage: 'Mensaje de error', originAccountID: 'Cuenta de origen',
  originAvailabilityZone: 'Zona de disponibilidad de origen', originRegion: 'Región de origen',
  sourceOutpostArn: 'ARN de Outpost de origen',
};

const states = {
  STOPPED: 'Detenida', INITIATING: 'Iniciando', INITIAL_SYNC: 'Sincronización inicial',
  BACKLOG: 'Datos pendientes', CREATING_SNAPSHOT: 'Creando snapshot',
  CONTINUOUS: 'Replicación continua', PAUSED: 'En pausa', RESCAN: 'Reexaminando',
  STALLED: 'Sin progreso', DISCONNECTED: 'Desconectado',
  NOT_STARTED: 'No iniciado', IN_PROGRESS: 'En progreso', SUCCEEDED: 'Correcto',
  FAILED: 'Fallido', SKIPPED: 'Omitido', PENDING: 'Pendiente', LAUNCHED: 'Lanzado',
  TERMINATED: 'Terminado', RECOVERY: 'Recuperación', DRILL: 'Prueba de recuperación',
  FAILOVER: 'Hacia recuperación', FAILBACK: 'Retorno al origen',
  REGULAR: 'Normal', CONTAINS_MARKETPLACE_PRODUCT_CODES: 'Incluye productos de Marketplace',
  MISSING_VOLUME_ATTRIBUTES: 'Faltan atributos del volumen',
  MISSING_VOLUME_ATTRIBUTES_AND_PRECHECK_UNAVAILABLE: 'Faltan atributos y no hay comprobación previa',
  EXTENDED: 'Extendido', EXTENSION_ERROR: 'Error de extensión', NOT_EXTENDED: 'No extendido',
  READY_FOR_RECOVERY: 'Preparado para recuperación',
  WAIT: 'Espera', CREATE_SECURITY_GROUP: 'Crear grupo de seguridad',
  LAUNCH_REPLICATION_SERVER: 'Lanzar servidor de replicación',
  BOOT_REPLICATION_SERVER: 'Arrancar servidor de replicación',
  AUTHENTICATE_WITH_SERVICE: 'Autenticar con el servicio',
  DOWNLOAD_REPLICATION_SOFTWARE: 'Descargar software de replicación',
  CREATE_STAGING_DISKS: 'Crear discos de staging', ATTACH_STAGING_DISKS: 'Adjuntar discos de staging',
  PAIR_REPLICATION_SERVER_WITH_AGENT: 'Vincular servidor de replicación con el agente',
  CONNECT_AGENT_TO_REPLICATION_SERVER: 'Conectar agente al servidor de replicación',
  START_DATA_TRANSFER: 'Iniciar transferencia de datos',
  AGENT_NOT_SEEN: 'Agente sin contacto', SNAPSHOTS_FAILURE: 'Error en snapshots',
  NOT_CONVERGING: 'La replicación no converge', UNSTABLE_NETWORK: 'Red inestable',
  FAILED_TO_CREATE_SECURITY_GROUP: 'No se pudo crear el grupo de seguridad',
  FAILED_TO_LAUNCH_REPLICATION_SERVER: 'No se pudo lanzar el servidor de replicación',
  FAILED_TO_BOOT_REPLICATION_SERVER: 'No se pudo arrancar el servidor de replicación',
  FAILED_TO_AUTHENTICATE_WITH_SERVICE: 'No se pudo autenticar con el servicio',
  FAILED_TO_DOWNLOAD_REPLICATION_SOFTWARE: 'No se pudo descargar el software de replicación',
  FAILED_TO_CREATE_STAGING_DISKS: 'No se pudieron crear los discos de staging',
  FAILED_TO_ATTACH_STAGING_DISKS: 'No se pudieron adjuntar los discos de staging',
  FAILED_TO_PAIR_REPLICATION_SERVER_WITH_AGENT: 'No se pudo vincular el agente',
  FAILED_TO_CONNECT_AGENT_TO_REPLICATION_SERVER: 'No se pudo conectar el agente',
  FAILED_TO_START_DATA_TRANSFER: 'No se pudo iniciar la transferencia de datos',
};

const label = key => Object.prototype.hasOwnProperty.call(labels, key)
  ? labels[key] : key.replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/_/g, ' ');
const object = value => value !== null && typeof value === 'object' && !Array.isArray(value);
const scalarList = value => Array.isArray(value) && value.every(item => !object(item) && !Array.isArray(item));

function formatted(value, key) {
  if (value === null || value === undefined || value === '') return missing;
  if (typeof value === 'boolean') return value ? 'Sí' : 'No';
  if (Array.isArray(value)) return value.length ? value.map(item => formatted(item, key)).join(', ') : missing;
  if (object(value)) return Object.entries(value).map(([field, item]) => `${label(field)}: ${formatted(item, field)}`).join('; ') || missing;
  if (typeof value === 'number') {
    if (key === 'bytes' || key.endsWith('Bytes')) {
      return value >= 0 && Number.isFinite(value)
        ? (value / (1024 ** 3)).toLocaleString('es-MX', { maximumFractionDigits: 2 }) : String(value);
    }
    return value.toLocaleString('es-MX');
  }
  if (key.endsWith('DateTime') && /^\d{4}-\d{2}-\d{2}T.*(?:Z|[+-]\d{2}:\d{2})$/.test(value)) {
    const date = new Date(value);
    if (!Number.isNaN(date.getTime())) return date.toLocaleString('es-MX', {
      timeZone: 'America/Mexico_City', hourCycle: 'h23',
    }) + ' · México';
  }
  if (key.endsWith('Duration')) {
    const parts = /^P(?:(\d+)D)?(?:T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+(?:\.\d+)?)S)?)?$/.exec(value);
    if (parts && parts.slice(1).some(part => part !== undefined)) {
      return parts.slice(1).flatMap((part, index) => part === undefined ? [] : [
        `${Number(part).toLocaleString('es-MX')} ${['d', 'h', 'min', 's'][index]}`,
      ]).join(' ');
    }
  }
  const stateField = ['dataReplicationState', 'lastLaunchResult', 'replicationDirection', 'volumeStatus',
    'state', 'status', 'type', 'name', 'error'].includes(key);
  return stateField && Object.prototype.hasOwnProperty.call(states, value) ? `${states[value]} (${value})` : String(value);
}

function flattened(value, prefix = []) {
  if (!object(value)) return [{ path: prefix, value }];
  const entries = Object.entries(value);
  return entries.length ? entries.flatMap(([key, child]) => flattened(child, [...prefix, key]))
    : [{ path: prefix, value: null }];
}

function Table({ title, columns, rows }) {
  return (
    <div className="overflow-x-auto rounded-xl border border-violet-300/15 bg-black/20">
      <table className="w-full text-xs text-left">
        <caption className="text-left px-4 py-3 bg-violet-500/10 text-sm font-semibold text-violet-100">{title}</caption>
        <thead className="border-y border-white/10 text-white/60">
          <tr>{columns.map((column, index) => <th scope="col" key={index} className="px-4 py-2 font-medium">{column}</th>)}</tr>
        </thead>
        <tbody className="divide-y divide-white/5">
          {rows.map((row, index) => <tr key={index} className="even:bg-white/[0.02]">
            {row.map((cell, cellIndex) => cellIndex === 0
              ? <th scope="row" key={cellIndex} className="px-4 py-2.5 align-top font-medium text-violet-200 break-words">{cell}</th>
              : <td key={cellIndex} className="px-4 py-2.5 align-top text-white/90 break-words [overflow-wrap:anywhere]">{cell}</td>)}
          </tr>)}
        </tbody>
      </table>
    </div>
  );
}

function Section({ title, data }) {
  const fields = flattened(data);
  const scalar = fields.filter(field => !Array.isArray(field.value) || scalarList(field.value));
  const lists = fields.filter(field => Array.isArray(field.value) && !scalarList(field.value));
  return (
    <section className="space-y-3">
      <Table title={title} columns={['Campo', 'Valor']} rows={scalar.length ? scalar.map(({ path, value }) => [
        path.map(label).join(' · ') || 'Información', formatted(value, path.at(-1) || ''),
      ]) : [['Información', 'Ver tablas de detalle.']]} />
      {lists.map(({ path, value }) => {
        const items = value.flatMap(item => Array.isArray(item) ? item : [item]).map(item => flattened(item));
        const columns = [...new Set(items.flatMap(item => item.map(field => JSON.stringify(field.path))))];
        return <Table key={path.join('.')} title={`${title} · ${path.map(label).join(' · ')}`}
          columns={['#', ...columns.map(column => JSON.parse(column).map(label).join(' · ') || 'Valor')]}
          rows={items.map((item, index) => [String(index + 1), ...columns.map(column => {
            const field = item.find(entry => JSON.stringify(entry.path) === column);
            return field ? formatted(field.value, field.path.at(-1) || '') : missing;
          })])} />;
      })}
    </section>
  );
}

export default function InventoryDrsDetails({ attributes }) {
  const groups = [
    ['sourceProperties', 'Servidor de origen'],
    ['dataReplicationInfo', 'Estado y detalle de replicación'],
    ['lifeCycle', 'Ciclo de vida y recuperación'],
    ['stagingArea', 'Área de staging'],
    ['sourceCloudProperties', 'Infraestructura cloud de origen'],
  ];
  const keys = groups.map(([key]) => key);
  const identity = Object.fromEntries(Object.entries(attributes).filter(([key]) => !keys.includes(key)));
  return (
    <div className="space-y-4">
      {Object.keys(identity).length > 0 && <Section title="Identificación y recuperación" data={identity} />}
      {groups.map(([key, title]) => <Section key={key} title={title} data={attributes[key] ?? null} />)}
    </div>
  );
}
